'use client'

import { useBreakpoint } from '@repo/web-ui/hooks/use-breakpoints'
import type { Project } from '../../page-client'
import { ProjectVoteButton } from './project-vote-button'
import * as React from 'react'
import { ProjectCommentButton } from './project-comment-button'
import { ProjectTipButton } from './project-tip-button'
import { ProjectBookmarkButton } from './project-bookmark-button'
import { ProjectShareButton } from './project-share-button'

export const ProjectActions = ({
  project,
  hideBookmark = false,
  onClick,
}: {
  project: Project
  onClick?: () => void
  hideBookmark?: boolean
}) => {
  const { breakpoint } = useBreakpoint()
  const isMobile = ['xs', 'sm'].includes(breakpoint ?? '')

  return (
    <div className={'flex mt-3 w-full flex-wrap items-center justify-start space-x-3'}>
      <ProjectVoteButton project={project} size={isMobile ? 'small' : 'regular'} />
      <ProjectCommentButton
        commentCount={project.commentsCount}
        size={isMobile ? 'small' : 'regular'}
        onClick={() => onClick?.()}
      />
      <ProjectTipButton project={project} size={isMobile ? 'small' : 'regular'} />
      {isMobile ? null : (
        <ProjectShareButton project={project} size={isMobile ? 'small' : 'regular'} />
      )}
      {isMobile || hideBookmark ? null : (
        <ProjectBookmarkButton project={project} size={isMobile ? 'small' : 'regular'} />
      )}
    </div>
  )
}
